import React, { Suspense, useEffect, useCallback } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
  Redirect,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./App.scss";
import ScrollToTop from "../utils/ScrollToTop";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import MeetPage from "../pages/MeetPage/MeetPage";

import { MeetPage_Dr } from "../pages/MeetPage_Dr/MeetPage_Dr";
import { MeetPage_Pt } from "../pages/MeetPage_Pt/MeetPage_Pt";
import "slick-carousel/slick/slick.css";

import "slick-carousel/slick/slick-theme.css";

import { createMuiTheme } from "@material-ui/core/styles";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import "../styles/common.css";
import PageLoader from "./PageLoader/PageLoader";
import OnBoard from "./OnBoardProjectSelection/OnboardProject";
import useIdleTimer from "../Hooks/useIdleTimer";
import { logoutAction } from "../actions/LoginAction";
import { SESSION_TIMEOUT_MS } from "../constants/const";
import DeviceRestrictionModal from "./Modals/RestrictionModal/DeviceRestrictionModal";
import NetworkStatusIndicator from "./NetworkStatusIndicator/NetworkStatusIndicator";
import { SpokeConsultation } from "../pages/zoom-video-consultation/ConsultationLanding";
import FloatingConsultation from "./FloatingConsultation/FloatingConsultation";
import { showFloatingConsultation } from "../actions/RPMAction";

const SignupPage = React.lazy(() => import("../pages/Signup"));

const VerificationCodePage = React.lazy(() => import("../pages/Verification"));
const SigninPage = React.lazy(() => import("../pages/Signin"));

const ResetPasswordPage = React.lazy(() => import("../pages/ResetPassword"));

const ConfirmPasswordPage = React.lazy(
  () => import("../pages/ConfirmPassword")
);
const ResetPasswordBridge = React.lazy(
  () => import("../pages/ResetPasswordBridge/ResetPasswordBridge")
);

const PasswordChangePage = React.lazy(() => import("../pages/PasswordChange"));
const Dashboard = React.lazy(() => import("../components/Dashboard/Dashboard"));
const ConsulationEnd = React.lazy(
  () => import("../components/RpmV2Components/ConsultationEnd/ConsultationEnd")
);
// const PrescriptionCrPage = React.lazy(() =>
//   import("../pages/PriscriptionCr/Index")
// );
const ViewPrescription = React.lazy(
  () =>
    import("../components/PrescriptionForm/ViewPrescription/ViewPrescription")
);
// const ConsultationScreen = React.lazy(() =>
//   import("../pages/ConsultationScreen/ConsultationScreen")
// );

// const Zoomconnect = React.lazy(() =>
//   import("../pages/ConsultationScreen/ZoomConnect")
// );
// const ZoomPatientconnect = React.lazy(() =>
//   import("../pages/ConsultationScreen/ZoomPatientConsultation")
// );

const ZoomDoctoruiKit = React.lazy(
  () => import("../pages/ConsultationScreen/ZoomDoctoruiKit")
);
const ZoomPatientUIKit = React.lazy(
  () => import("../pages/ConsultationScreen/ZoomPatientUIKit")
);

const SessionExpired = React.lazy(
  () => import("../pages/SessionExpired/SessionExpired")
);

const RpmHomeNew = React.lazy(() => import("../pages/rpm-v2/RpmV2Page"));
const Test = React.lazy(() => import("../pages/Test/Test"));
const ProjectListingPage = React.lazy(
  () => import("../pages/ProjectListingPage")
);
const notfound = React.lazy(() => import("../pages/PageNotfound"));
const HOPIPage = React.lazy(() => import("./RpmV2Components/Hopi/HOPIPage"));
const HOPIDemo = React.lazy(() => import("../pages/HOPIDemo"));
const PhysicalExaminationPage = React.lazy(
  () => import("./RpmV2Components/PhysicalExamination/PhysicalExaminationPage")
);

const ProtectedRoute = ({ component: Component, ...rest }) => {
  let userData = null;
  try {
    const rawData = localStorage.getItem("userData");
    userData = rawData ? JSON.parse(rawData) : null;
  } catch (err) {
    console.error("Error parsing userData in ProtectedRoute", err);
  }

  const isAuthenticated =
    userData && (userData.userId || userData.token || userData.profileId);
  console.info("ProtectedRoute here", isAuthenticated);
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/signin" />
      }
    />
  );
};

const AppContent = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleIdle = useCallback(() => {
    let currentUserData = null;
    try {
      const rawData = localStorage.getItem("userData");
      currentUserData = rawData ? JSON.parse(rawData) : null;
    } catch (err) {
      console.error("Error parsing userData in handleIdle", err);
    }

    console.info("DEBUG: handleIdle triggered. userData:", currentUserData);
    // Check for presence of user data to determine if logged in
    if (currentUserData && (currentUserData.userId || currentUserData.token || currentUserData.profileId)) {
      console.info(
        "DEBUG: handleIdle - user is logged in. Checking consultation skip..."
      );
      // Check if any tab is in a consultation (cross-tab protection)
      const lastConsultationActivity = localStorage.getItem(
        "last_consultation_activity"
      );
      if (lastConsultationActivity) {
        const lastActivityTime = parseInt(lastConsultationActivity, 10);
        const currentTime = Date.now();
        // If there was consultation activity in the last 30 seconds, skip logout
        if (currentTime - lastActivityTime < 30000) {
          console.info(
            "DEBUG: Logout skipped: Active consultation detected in another tab."
          );
          return;
        }
      }

      console.info("DEBUG: handleIdle - proceeding with logoutAction.");
      dispatch(logoutAction(currentUserData, history));
    } else {
      console.info(
        "DEBUG: handleIdle - user NOT logged in (no userId/token/profileId)."
      );
    }
  }, [dispatch, history]);

  useEffect(() => {
    const handleStorageChange = (e) => {
      // e.key === null when localStorage.clear() is called in another tab
      if (e.key === "userData" || e.key === null) {
        const hasUserData = !!localStorage.getItem("userData");
        if (!hasUserData) {
          console.log("Session cleared in another tab. Logging out...");

          // Use the centralized logoutAction to ensure all state is cleared and history is updated
          let currentUserData = null;
          try {
            const rawData = localStorage.getItem("userData");
            currentUserData = rawData ? JSON.parse(rawData) : null;
          } catch (err) {
            console.error("Error mapping userData for logout", err);
          }
          dispatch(logoutAction(currentUserData, history));
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [dispatch, history]);

  const location = useLocation();
  const isConsultationPage =
    location.pathname.includes("/consultation") ||
    location.pathname.includes("/ptconsultation/") ||
    location.pathname.includes("/meet") ||
    location.pathname.includes("/meet_dr") ||
    location.pathname.includes("/meet_pt/");

  useEffect(() => {
    let intervalId;
    if (isConsultationPage) {
      // Heartbeat: Update localStorage every 10 seconds while on consultation page
      const updateHeartbeat = () => {
        localStorage.setItem(
          "last_consultation_activity",
          Date.now().toString()
        );
      };
      updateHeartbeat();
      intervalId = setInterval(updateHeartbeat, 10000);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
      // Optional: Don't clear immediately to allow small grace period/transition
    };
  }, [isConsultationPage]);

  useEffect(() => {
    // Restore floating consultation state from localStorage on refresh
    const storedFloating = localStorage.getItem("floatingdetails");
    if (storedFloating) {
      try {
        const { appointmentId, role } = JSON.parse(storedFloating);
        if (appointmentId && role) {
          console.log("Restoring floating consultation session:", appointmentId);
          dispatch(showFloatingConsultation(appointmentId, role));
        }
      } catch (err) {
        console.error("Error restoring floating consultation state:", err);
      }
    }
  }, [dispatch]);

  useIdleTimer(handleIdle, SESSION_TIMEOUT_MS, isConsultationPage);

  return (
    <Suspense fallback={<PageLoader />}>
      <ScrollToTop />
      <NetworkStatusIndicator />
      <ToastContainer style={{ zIndex: 20000 }} limit={1} />
      <FloatingConsultation />
      {/* <DeviceRestrictionModal minWidth={1280} />*/}
      <Switch>
        <Route exact path="/" component={SigninPage} />
        <Route exact path="/microsites" component={SigninPage} />
        <Route exact path="/homepage" component={SigninPage} />
        {/* <Route
      path="/projectlisting/:drId"
      component={ProjectListingPage}
    />  */}
        <ProtectedRoute path="/projectlisting/:drId" component={OnBoard} />
        <ProtectedRoute path="/projectlisting" component={OnBoard} />
        <Route exact path="/sessionExpired" component={SessionExpired} />
        <Route exact path="/signup" component={SignupPage} />
        <Route exact path="/consultationend" component={ConsulationEnd} />
        <Route exact path="/signup/verify" component={VerificationCodePage} />
        <Route exact path="/patientmail/:key" component={ResetPasswordBridge} />
        <Route exact path="/doctormail/:key" component={ResetPasswordBridge} />
        {/* <Route
      exact
      path="/admindashboard"
      component={PrescriptionCrPage}
    />
    */}
        <ProtectedRoute
          exact
          path="/viewprescription/:prname"
          component={ViewPrescription}
        />
        <ProtectedRoute path="/rpm" component={RpmHomeNew} />
        <ProtectedRoute path="/bridge" component={RpmHomeNew} />
        <Route path="/signin" component={SigninPage} />
        <Route path="/login" component={SigninPage} />
        <Route path="/reset" component={ResetPasswordPage} />
        <ProtectedRoute path="/dashboard" component={Dashboard} />
        <ProtectedRoute path="/meet" component={MeetPage} />
        {/* <ProtectedRoute
          path="/consultation/:appointmentId"
          component={DoctorConsultation}
        />
        <ProtectedRoute
          path="/ptconsultation/:appointmentId"
          component={PatientConsultation}
        /> */}
        <Route path="/test" component={Test} />
        <ProtectedRoute path="/hopi" component={HOPIPage} />
        <ProtectedRoute path="/hopi-demo" component={HOPIDemo} />
        <ProtectedRoute path="/pe" component={PhysicalExaminationPage} />
        <ProtectedRoute path="/meet_dr" component={MeetPage_Dr} />
        <ProtectedRoute
          path="/meet_pt/:appointmentId"
          component={MeetPage_Pt}
        />
        <Route exact path="/confirmpassword" component={ConfirmPasswordPage} />
        <Route exact path="/passwordchange" component={PasswordChangePage} />
        {/* <Route exact path="/mircrosite/:clinicId" component={OurDoctorPage}/> */}
        {/* <Route path="/termsofUse" component={TermsandConditions} /> */}
      </Switch>
    </Suspense>
  );
};

function App() {
  // const customTheme = createMuiTheme({
  const customTheme = createTheme({
    overrides: {
      MuiInput: {
        input: {
          "&::placeholder": {
            color: "rgb(119, 119, 119)!important",
            opacity: ".9 !important",
            fontSize: "14px !important",
          },
          color: "black", // if you also want to change the color of the input, this is the prop you'd use
        },
      },
      MuiAutoComplete: {
        input: {
          "&::placeholder": {
            color: "rgb(119, 119, 119)!important",
            opacity: "1 !important",
            fontSize: "14px !important",
          },
          color: "black", // if you also want to change the color of the input, this is the prop you'd use
        },
      },

      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: "#0a8ce0",
        },
      },
      MuiPickersCalendarHeader: {
        switchHeader: {
          // backgroundColor: lightBlue.A200,
          // color: "white",
        },
      },
      MuiPickersDay: {
        day: {
          color: "#0a8ce0",
        },
        daySelected: {
          backgroundColor: "#0a8ce0",

          "&:hover": {
            backgroundColor: "#0a8ce0",
          },
        },
      },
    },
  });

  return (
    <>
      <ThemeProvider theme={customTheme}>
        {/* <Router basename={'/ROOT/'}> */}
        <Router basename={"/ccdc/"}>
          <div>
            <AppContent />
          </div>
        </Router>
      </ThemeProvider>
    </>
  );
}

export default App;
